import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'NHL Network™',
    callsign: 'NHLNET',
    logoUrl: networkLogos.nhlnetwork.logoUrl,
    slug: 'nhl-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="NHLNET"
        title="Watch NHL Network™ live with Fubo"
        networkName="NHL Network™"
        // matchtickerSportId="122"
        // matchtickerLeagueName="NHL"
        // matchtickerLeagueId="191278"
      />
    </>
  )
}
